<template>
  <div class="pre-registration">
    <!-- 主内容 -->
    <div>
      <div class="header" style="text-align: center;">
        <img v-if="logoUrl" :src="logoUrl" alt="Logo" class="logo"/>
        <div v-else class="logo-placeholder"></div>
      </div>
      <el-form ref="formRef" :model="form" label-width="100px" class="form" :disabled="isDisabled">
        <h5 style="text-align: center;">{{ title }}</h5>
        <el-form-item label="姓名">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证件号码">
          <el-input v-model="form.idNumber" placeholder="请输入身份证号码"></el-input>
        </el-form-item>
        <el-form-item label="预报名号">
          <el-input v-model="form.registrationNumber" placeholder="请输入预报名号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm" :disabled="isDisabled">查询</el-button>
        </el-form-item>
        <div v-if="hint" class="hint">提示：{{ hint }}</div>
      </el-form>
      
      <!-- 静态版权声明 -->
      <div class="copyright">
        <p>系统开发：吴起航  |  美工设计：蔡资潇</p>
        <p>© 2024-2025 起航工作室版权所有</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElForm, ElFormItem, ElInput, ElButton, ElMessage, ElMessageBox, ElLoading } from 'element-plus';
import axios from 'axios';

export default {
  name: 'PreRegistration',
  components: {
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
  },
  setup() {
    const title = ref('');
    const form = ref({
      name: '',
      idNumber: '',
      registrationNumber: '',
    });
    const hint = ref('');
    const isDisabled = ref(false);
    const router = useRouter();
    const logoUrl = ref('');

    const fetchTitle = async () => {
      try {
        const response = await axios.get('/api/title');
        title.value = response.data.title;
      } catch (error) {
        console.error('Error fetching title:', error);
      }
    };

    const fetchHint = async () => {
      try {
        const response = await axios.get('/api/hint');
        hint.value = response.data.hint;
      } catch (error) {
        console.error('Error fetching hint:', error);
        ElMessage.error('无法获取提示信息');
      }
    };

    const fetchLogo = async () => {
      try {
        const response = await axios.get('/api/logo', { responseType: 'blob' });
        logoUrl.value = URL.createObjectURL(response.data);
      } catch (error) {
        console.error('Error fetching logo:', error);
        ElMessage.error('无法获取Logo');
      }
    };

    const checkDisabledState = () => {
      const disabledUntil = localStorage.getItem('disabledUntil');
      const now = new Date().getTime();

      if (disabledUntil && now < disabledUntil) {
        isDisabled.value = true;
        const timeout = disabledUntil - now;
        setTimeout(() => {
          isDisabled.value = false;
          localStorage.removeItem('disabledUntil');
        }, timeout);
      }
    };

    const submitForm = async () => {
      if (isDisabled.value) {
        ElMessage.error('操作过于频繁，请稍后再试');
        return;
      }

      if (!form.value.name || !form.value.idNumber || !form.value.registrationNumber) {
        ElMessage.error('请填写所有信息');
        return;
      }

      try {
        const response = await axios.post('/find', form.value);
        if (response.data.code === 1) {
          localStorage.setItem('admittedStudentName', form.value.name);
          router.push('/success');
        } else {
          handleError();
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        ElMessage.error('提交失败，请稍后重试');
      }
    };

    const handleError = () => {
      let errorCount = parseInt(localStorage.getItem('errorCount') || '0', 10);
      errorCount += 1;

      if (errorCount >= 20) {
        const disabledUntil = new Date().getTime() + 5 * 60 * 1000;
        localStorage.setItem('disabledUntil', disabledUntil.toString());
        localStorage.setItem('errorCount', '0');
        isDisabled.value = true;
        setTimeout(() => {
          isDisabled.value = false;
        }, 5 * 60 * 1000);
        ElMessage.error('您已多次提交错误信息，请5分钟后再试');
      } else {
        localStorage.setItem('errorCount', errorCount.toString());
        ElMessageBox.alert('未查询到录取信息，请检查输入的信息是否正确', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
        });
      }
    };

    onMounted(async () => {
      const loadingInstance = ElLoading.service({ 
        fullscreen: true,
        text: '当前访问人数较多，加载中' // 设置加载指示器的文本
      });

      await Promise.all([
        fetchTitle(),
        fetchHint(),
        fetchLogo()
      ]);

      loadingInstance.close(); // 在所有数据加载完成后关闭加载指示器
      checkDisabledState();
    });

    return {
      form,
      submitForm,
      hint,
      isDisabled,
      title,
      logoUrl,
    };
  },
};
</script>

<style scoped>
.pre-registration {
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.header {
  display: grid;
  place-items: center;
  width: 100%; /* 确保容器占满可用宽度 */
  height: auto;
  margin-bottom: 5px;
}

.logo-placeholder {
  width: 30px;
  height: 30px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.form {
  margin-top: 5px;
  flex: 1;
}

.hint {
  color: red;
  margin-top: 10px;
}

/* 版权声明样式 */
.copyright {
  text-align: center;
  margin-top: 30px;
  padding: 15px;
  font-size: 12px;
  color: #666;
}

.logo {
  width: 70px; /* 设置宽度 */
  height: auto; /* 保持原始比例 */
  display: block;
  text-align: center;
  align-items: center;
}
</style>
